// core
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// services
import { RaptorDataService } from '../../../services/raptor-data.service';
import { RaptorStepService } from '../../../services/raptor-step.service';

/* default section layout settings */
let section_settings = {
  "size": "<small|medium|large>", // default - large
  "align": "<left|center|right>", // default - center
  "card": "<true|null>", // default - null
  "banner": "<src|html|null>", // default - null
  "column_size": "<small|medium|large>", // default - large
  "hero": "<url|null>", // default - null
  "hero_size": "<small|medium|large>", // default - medium (currently not implemented)
  "hero_align": "<left|center|right>" // default - left (currently not implemented)
}

@Component({
  selector: 'open-raptor-section-default',
  templateUrl: './raptor-section-default.component.html',
  styleUrls: ['./raptor-section-default.component.scss']
})
export class RaptorSectionDefaultComponent implements OnInit {
  @Input() section: any;
  @Input() form!: FormGroup;
  questions: Array<any> = [];
  sectionClass: string = '';
  heroType: string = '';
  columns: number = 1;

  constructor(
    public raptorDataService: RaptorDataService,
    public raptorStepService: RaptorStepService
  ) { }

  ngOnInit(): void {
    this.section.settings = this.section.settings || {};
    let layoutConfig = this.raptorDataService.columnLayout(this.section.settings.columns, this.section.settings.rows, this.section.elements, this.section.settings.components);

    this.questions = layoutConfig.questions;
    this.columns = layoutConfig.columns;

    if (this.section.settings) {
      // apply layout settings for the section
      if (this.section.settings.card === true) {
        this.sectionClass += 'raptor-section-card ';
      }
      if (this.section.settings.banner) {
        this.sectionClass += 'has-banner ';
      }
      if (this.section.settings.hero) {
        this.heroType = this.section.settings.hero.split('.').pop().toLowerCase();
      }
      if (this.section.settings.spacing) {
        this.sectionClass += `spacing-${this.section.settings.spacing} `;
      }
    } else {
      this.section.settings = {};
    }
  }
}
